define('services/common/ajax/hiGame',['app'], function (app) {
    app.factory('Higame', ['auiAjaxWithError', function (auiAjaxWithError) {
        return {
            getGameBuoyKey: auiAjaxWithError.curryOld('Higame.gss.getGameBuoyKey')
        }
    }])
});
